import { MessageBarType } from '@fluentui/react';
import { IPMessageBar, IPText } from 'baseComponents';
import { copilotIconProps } from 'globalStyles';
import { ReactNode } from 'react';

interface IAISuggestionMessageProps {
  message?: string;
  onDismiss?: () => void;
  children?: ReactNode;
}

const AISuggestionMessage = (props: IAISuggestionMessageProps) => {
  if (props.message === undefined && props.children === undefined) {
    return null;
  }

  return (
    <IPMessageBar
      messageBarType={MessageBarType.info}
      onDismiss={props.onDismiss}
      isMultiline={true}
      truncated={false}
      messageBarIconProps={copilotIconProps}
    >
      {props.message && (
        <IPText block>
          {props.message}
        </IPText>
      )}
      {props.children}
    </IPMessageBar>
  );
};

export default AISuggestionMessage;
